import { Button } from '@codeparva/ui-components-library';
import React from 'react';
import { FontAwesomeIcon } from '../../../utilities/iconLoader/FontAwesomeIcon';

export const AccountRestricted = () => {
  return (
    <div className="AccountParentContainer">
      <div className="accountChildContainer">
        <div className="informationContainer">
          <FontAwesomeIcon
            iconClassName="FaExclamationCircle"
            iconContextProps={{ className: 'accountErrorIconColor' }}
          />

          <p className="restrictionMessage titleColor">
            This Account is Restricted
          </p>

          <div className="smallMessageSection titleColor">
            <p>Please Contact the Facility</p>
          </div>
        </div>
        <div className="accountCtaButton">
          <Button color="primary">Contact Us</Button>
        </div>
      </div>
    </div>
  );
};
